export default __webpack_public_path__ + "static/signup-illustration-28d4ca43d0c782ccdb26336fa4a4dbcb.jpg";